import React from "react";
import "./InputField.scss";

interface InputFieldProps {
  type?: "text" | "email" | "password" | "number" | "tel" | "date";
  name: string;
  value: string | number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  label?: string;
  error?: string;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  icon?: React.ReactNode;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  autoComplete?: string;
  min?: string | number;
  max?: string | number;
  step?: string | number;
  autoFocus?: boolean;
}

const InputField: React.FC<InputFieldProps> = ({
  type = "text",
  name,
  value,
  onChange,
  placeholder = "",
  label,
  error,
  required = false,
  disabled = false,
  className = "",
  icon,
  onBlur,
  autoComplete = "off",
  min,
  max,
  step,
  autoFocus,
}) => {
  // Handle display value for number inputs
  const displayValue = type === "number" && value === "" ? "" : value;

  // Handle change event for number inputs
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (type === "number") {
      // For empty string, convert to 0 before passing to parent
      const newValue = e.target.value === "" ? "" : e.target.value;
      e.target.value = newValue;
    }
    onChange(e);
  };

  return (
    <div className={`input-field ${className}`}>
      {label && (
        <label htmlFor={name} className="input-label">
          {label}
          {required && <span className="required-asterisk">*</span>}
        </label>
      )}

      <div className={`input-container ${error ? "error" : ""}`}>
        {icon && <span className="input-icon">{icon}</span>}
        <input
          type={type}
          id={name}
          name={name}
          value={displayValue}
          onChange={handleChange}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          onBlur={onBlur}
          autoComplete={autoComplete}
          className={`input-element ${icon ? "with-icon" : ""}`}
          min={min}
          max={max}
          step={step}
          autoFocus={autoFocus}
        />
      </div>

      {error && <p className="error-message">{error}</p>}
    </div>
  );
};

export default InputField;